
import type { BannerCarrosselAppProps } from "./banner-carrossel.props"
import { BannerCarrossel } from "./components/BannerCarrossel"

export default class BannerApp {
     constructor(props: BannerCarrosselAppProps) {
        const el = document.getElementById(props.id)
        if (!el) return

        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(<BannerCarrossel {...props} />)
    }
}
